var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-card"},[_vm._t("product",null,{"info":_vm.info,"marketplaces":_vm.marketplaces,"quntity":_vm.quantity,"link":_vm.link,"isFav":_vm.isFav,"inBasket":_vm.inBasket,"addToBasket":_vm.addToBasket,"addToFavs":_vm.addToFavs,"moduleBasket":_vm.moduleBasket,"moduleFavorites":_vm.moduleFavorites})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }